import { BrokerDisposableHandler } from "@uxland/primary-shell";
import { HandleHistoryItemsAddError } from "./request";
import { HandleHistoryItemsAddErrorHandler } from "./handler";
import { BrokerExtensions } from "@primaria/plugins-core";

let request: BrokerDisposableHandler;

export const bootstrapHandleHistoryItemsAddError = (broker: BrokerExtensions) => {
  teardownHandleHistoryItemsAddError();
  request = broker.registerRequest(HandleHistoryItemsAddError, HandleHistoryItemsAddErrorHandler);
};

export const teardownHandleHistoryItemsAddError = () => {
  request?.dispose();
};
